export const ROUTES = {
  ROOT: '/',
  AI_USAGE: '/ai-usage',
  CONTACT_US: '/contact-us',
  COOKIE_PREFERENCES: '/cookie-preferences',
  CLEVERSCORE: '/cleverscore',
  LEGAL_NOTICES: '/legal-notices',
  PERSONAL_DATA: '/personal-data',
  PROFILE: '/profile',
  TERMS_OF_USE: '/terms-of-use',
  CONSULTANT_DETAIL: '/consultants/$consultantId',
  CONSULTANTS_LIST: '/consultants',
  MY_NETWORK: '/my-network',
  BACKOFFICE: '/backoffice',
  INVITE_STAFF: '/backoffice/invitations',
  MY_COOPTATIONS: '/my-cooptations',
  ADMIN: '/admin',
  RECOMMEND: '/recommend',
} as const
